import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { ArbitroOfflineAssertions } from '../../system/PlanillaPartidoOffline/ArbitroOfflineAssertions';
import { OficialDeMesaOfflineAssertions } from '../../system/PlanillaPartidoOffline/OficialDeMesaOfflineAssertions';

class OficialDeMesaOfflineForm extends CustomForm {
  protected constructor(
    odmo_id: string | null,
    odmo_nro_doc: string,
    odmo_nombre: string,
    odmo_apellido: string
  ) {
    const odmoff = OficialDeMesaOfflineAssertions.build();
    super('OficialDeMesaOffline', odmoff);
    this.addInputAsserted('odmo_id', odmo_id);
    this.addInput('odmo_nro_doc', odmo_nro_doc);
    this.addInput('odmo_nombre', odmo_nombre);
    this.addInput('odmo_apellido', odmo_apellido);
  }

  private static build(
    odmo_id: string | null,
    odmo_nro_doc: string,
    odmo_nombre: string,
    odmo_apellido: string
  ) {
    return new this(odmo_id, odmo_nro_doc, odmo_nombre, odmo_apellido);
  }

  static initialize() {
    return this.build(null, '', '', '');
  }

  getIdInput() {
    return this.getInputByName('odmo_id');
  }

  getNroDocInput() {
    return this.getInputByName('odmo_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('odmo_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('odmo_apellido');
  }
}

export default OficialDeMesaOfflineForm;
